import { useTranslation } from 'react-i18next';

export const TEXTS = {
  minAgeNotInRangeError: 'Min age input must be between 19 and 99',
  maxAgeNotInRangeError: 'Max age input must be between 19 and 99',
  maxAgeSmallerThanMinAgeError: 'Max age input must be bigger or the same as min age input',
};

export type ValidationResponse = {
  minAge: { error: boolean; helperText: string };
  maxAge: { error: boolean; helperText: string };
};

export const useDemographicsAgeValidation = (
  minAge: number,
  maxAge: number,
  ANY_AGE_VALUE: number
): ValidationResponse => {
  const validation: ValidationResponse = {
    minAge: { error: false, helperText: '' },
    maxAge: { error: false, helperText: '' },
  };
  const { t } = useTranslation();

  const checkIfValueInRange = (value: number): boolean => (value < 19 || value > 99) && value !== ANY_AGE_VALUE;
  const checkIfMaxValueIsBiggerThanMin = maxAge < minAge && maxAge !== 0;

  if (checkIfValueInRange(minAge)) {
    validation.minAge = { error: true, helperText: t(TEXTS.minAgeNotInRangeError) };
  }

  if (checkIfValueInRange(maxAge)) {
    validation.maxAge = { error: true, helperText: t(TEXTS.maxAgeNotInRangeError) };
  }

  if (checkIfMaxValueIsBiggerThanMin) {
    validation.maxAge = { error: true, helperText: t(TEXTS.maxAgeSmallerThanMinAgeError) };
  }

  return validation;
};
